//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { useCallback } from 'react';
import { Dashboard } from '../../interfaces/Dashboard';
//import { iconesMap } from '../../lib/icones';
//import api from '../../services/api';

interface DashboardHomeItemProperties {
  dashboard: Dashboard;
}

export function DashboardHomeItem({ dashboard }: DashboardHomeItemProperties) {
  // const handleAccess = useCallback(() => {
  //   api.put(`/dashboards/${dashboard.urn}/access`);
  // }, [dashboard.urn]);

  const handleAccess = () => {
    const w = window.screen.width;
    const h = window.screen.height;
    //const windowFeatures = `left=${(w*0.05).toString()},top=${(h*0.05).toString()},width=${(w*0.9).toString()},height=${(h*0.9).toString()}`;
    const windowFeatures = `left=${(w*0.12).toString()},top=${(h*0.1).toString()},width=${(w*0.85).toString()},height=${(h*0.72).toString()}`;
    //const windowFeatures = "left=100,top=100,width=" + "1280" + ",height=720";
    window.open(dashboard.externalUrl, "salasituacao", windowFeatures)
  }

  return (
    // <a href={dashboard.externalUrl} onClick={handleAccess} target="_blank" rel="noreferrer">
    // <a href={"#"} onClick={handleAccess}>
    //   <div className="home-item">
    //     <div>
    //       <h3 className='item-titulo item-caixa-home'>{dashboard.name}</h3>
    //     </div>
    //   </div>
    // </a>
    <button onClick={handleAccess} className='home-item item-titulo'>{dashboard.name}</button>
  );
};
